import React from 'react';
import '../../../App.css';
import Navbar2 from '../Navbar2';
import PricingComponents from '../PricingComponents';
import Footer from '../Footer';

function Pricing() {
  return (
    <>
      <Navbar2/>
      <PricingComponents/>
      <Footer/>
    </>
  );
}

export default Pricing;